import { render } from "./adabvarosoom.vue?vue&type=template&id=c0250b3a"
import script from "./adabvarosoom.vue?vue&type=script&lang=js"
export * from "./adabvarosoom.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/pamenar-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__